import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { PageContentPreloader, NoItemsPanel, SearchPanel } from 'common/components';
import { PaymentsTable } from 'backoffice/payments/_components';
import noPaymentsImage from 'common/images/noPayments.svg';

import { getCrmFinancesWithdrawals, getCrmFinancesPaymentSystems } from '../../_redux';

const CRMWithdrawalsTab = ({
  withdrawals,
  withdrawalsAreLoaded,
  paymentSystems,
  paymentSystemsAreLoaded,
  getCrmFinancesWithdrawals,
  getCrmFinancesPaymentSystems,
  location,
  history,
  intl,
}) => {
  const parsedSearch = useMemo(() => queryString.parse(location.search), [location.search]);
  const { tab, ...restSearch } = parsedSearch;
  const query = useMemo(() => ({ page_size: 10, ...restSearch }), [location.search]);

  useEffect(() => {
    if (tab !== 'withdraws') return;
    getCrmFinancesWithdrawals({ search: query });
  }, [getCrmFinancesWithdrawals, location.search]);

  useEffect(() => {
    getCrmFinancesPaymentSystems();
  }, [getCrmFinancesPaymentSystems]);

  const optionsPaymentSystemList = [];
  if (paymentSystemsAreLoaded) {
    paymentSystems.map(ps =>
      optionsPaymentSystemList.push({ value: ps.paymentSystemSlug, label: ps.paymentSystemSlug })
    );
  }

  const filters = [
    {
      title: 'justStatus',
      accessor: '_status',
      options: [
        { value: '', label: intl.formatMessage({ id: 'justAll' }) },
        { value: 'waiting_confirmation', label: intl.formatMessage({ id: 'status_waiting_confirmation' }) },
        { value: 'waiting_verification', label: intl.formatMessage({ id: 'status_waiting_verification' }) },
        { value: 'waiting_approval', label: intl.formatMessage({ id: 'status_waiting_approval' }) },
        { value: 'rejected', label: intl.formatMessage({ id: 'status_rejected' }) },
        { value: 'canceled', label: intl.formatMessage({ id: 'status_canceled' }) },
        { value: 'failed', label: intl.formatMessage({ id: 'status_failed' }) },
        { value: 'processing', label: intl.formatMessage({ id: 'status_processing' }) },
        { value: 'payout', label: intl.formatMessage({ id: 'status_payout' }) },
        { value: 'done', label: intl.formatMessage({ id: 'status_done' }) },
      ],
    },
    {
      title: 'paymentSystem',
      accessor: 'payment_system_slug',
      options: [{ value: '', label: intl.formatMessage({ id: 'justAll' }) }, ...optionsPaymentSystemList],
    },
  ];

  return (
    <div className="FinancesPage__withdrawals-tab">
      <PageContentPreloader ready={withdrawalsAreLoaded} type="smallLines" firstLaunchOnly>
        <SearchPanel
          location={location}
          history={history}
          getList={data => getCrmFinancesWithdrawals({ search: data.search })}
          filters={filters}
          params={{ search: query }}
        />
        {withdrawals.count ? (
          <PaymentsTable
            data={withdrawals}
            exportButtonCaptionSlug=""
            type="withdrawals"
            loading={!withdrawalsAreLoaded}
            location={location}
            history={history}
            getList={data => getCrmFinancesWithdrawals({ search: data.search })}
            onRowClick={() => {}}
            params={{ search: query }}
            allowManagePaymentsExports={false}
            hasPaymentOperationManagers={false}
            hideMetadataFilter
            disableLinks
            hideColumns={['boPaymentMethod', 'justPaymentTags']}
            noResponsive
          />
        ) : (
          <NoItemsPanel
            icon={noPaymentsImage}
            captionSlug={Object.keys(query).length ? 'noWithdrawalsMatchingTheParameters' : 'noPaymentsWithdrawals'}
          />
        )}
      </PageContentPreloader>
    </div>
  );
};

CRMWithdrawalsTab.propTypes = {
  withdrawals: PropTypes.object.isRequired,
  withdrawalsAreLoaded: PropTypes.bool.isRequired,
  paymentSystems: PropTypes.array.isRequired,
  paymentSystemsAreLoaded: PropTypes.bool.isRequired,
  getCrmFinancesWithdrawals: PropTypes.func.isRequired,
  getCrmFinancesPaymentSystems: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default compose(
  injectIntl,
  withRouter,
  connect(
    state => ({
      withdrawals: state.crm.finances.withdrawals,
      withdrawalsAreLoaded: state.crm.finances.withdrawalsAreLoaded,
      paymentSystems: state.crm.finances.paymentSystems,
      paymentSystemsAreLoaded: state.crm.finances.paymentSystemsAreLoaded,
    }),
    {
      getCrmFinancesWithdrawals: search => getCrmFinancesWithdrawals.request(search),
      getCrmFinancesPaymentSystems: () => getCrmFinancesPaymentSystems.request(),
    }
  )
)(CRMWithdrawalsTab);
